import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLineDoodle4 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 75,
	height: 8,
	viewBox: "0 0 75 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.04512 4.45962C18.8895 -0.496059 90.2729 4.52196 69.6699 5.08613C49.0669 5.6503 34.4403 3.49947 20.9895 5.84542",
		stroke: "#FFC14A",
		strokeWidth: 3,
		strokeLinecap: "round"
	})
});
export default SvgLineDoodle4;
